/**
 * Check email address status for zero_bounce_status formdata field
 * @param {String} email_field css selector for input type email
 * @param {Function} callback callback function to execute after ajax request
 */
function ZerobounceValidateEmail( email_field, callback ) {
	jQuery.ajax( {
		url: gocoderzAjax.url,
		type: "post",
		data: {
			action: "zerobounce_validate_email",
			nonce: gocoderzAjax.nonce,
			email: $( email_field ).val()
		},
		error: function ( response ) {
			callback( JSON.parse( response ) );
		},
		success: function ( response ) {
			callback( JSON.parse( response ) );
		}
	} );
}

export { ZerobounceValidateEmail };